// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U0HJW","rootMobile":"styles_rootMobile__2__5W"};